const SitemapXml = () => {
  return (
    <iframe
      src="https://www.novviproperties.com/sitemap.xml"
      title="Sitemap"
      width="100%"
      height="1000px"
      style={{ border: "none" }}
    />
  );
};

export default SitemapXml;
